import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import Text from '../Text';
import { DOVE_GRAY } from '../../styles';

const s = StyleSheet.create({
  label: {
    fontSize: 16,
    color: DOVE_GRAY,
    marginBottom: 8,
  },
});

const Label = ({ messageId }) => (
  <Text messageId={messageId} className={css(s.label)} />
);

Label.propTypes = {
  messageId: PropTypes.string.isRequired,
};

export default Label;
